import BikeSelector from './components/BikeSelector';
import PartsFinder from './components/PartsFinder';

Vue.component('bike-selector', BikeSelector);
Vue.component('parts-finder', PartsFinder);
